export default __webpack_public_path__ + "static/media/try-atomic-diet-display.59adf546.png";